import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Link, Typography } from '@material-ui/core'
import lattesIcon from 'src/assets/icons/social/lattes-icon.svg'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './CollaboratorLaboratoryGrid.styles'

type CollaboratorLaboratoryGridProps = {
  title: string
  data: {
    src: string
    name: string
    title?: string
    position: string
    lattesUrl?: string
  }[]
}

const CollaboratorLaboratoryGrid = ({
  title,
  data
}: CollaboratorLaboratoryGridProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const classesGlobal = useGlobalStyles()

  return (
    <Box className={classes.container}>
      <Typography variant="h3" className={classesGlobal.titleSection}>
        {t(title)}
      </Typography>
      <Box className={classes.containerGridBackground}>
        <Grid container className={classes.gridContainer} spacing={4}>
          {data.map((line, index) => (
            <Grid
              item
              className={classes.gridItem}
              key={index}
              xs={6}
              sm={6}
              md={3}
            >
              <img
                src={line.src}
                alt={line.name}
                title={line.name}
                className={classes.collaboratorImg}
              />
              <Typography variant="body1" className={classes.name}>
                {t(line.name)}
                {line.title && ` (${t(line.title)})`}
              </Typography>
              <Typography variant="body2" className={classes.position}>
                {t(line.position)}
              </Typography>
              <Box className={classes.collaboratorLinkGroup}>
                {line.lattesUrl && (
                  <Link
                    href={line.lattesUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.collaboratorLink}
                    title="lattes"
                  >
                    <img
                      src={lattesIcon}
                      alt="lattes"
                      className={classes.collaboratorLink}
                    />
                  </Link>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

export default CollaboratorLaboratoryGrid
